import _defineProperty from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
/**
 * A client to call events against window.chord for Chord CDP.
 *
 * This client was manually created based on ../segment/typewriter/index.ts. All
 * events called within ../index.ts are supported.
 *
 * Because Chord CDP's API is compatible with Segment's, we can use the same
 * types, and all that really changes is the object the events are called
 * against. Using a different object allows us to call events to both Segment
 * and Chord CDP at the same time (largely for testing purposes).
 */
var analytics = function analytics() {
  return window.chord;
};
/**
 * Helper to attach metadata on Typewriter to outbound requests.
 * This is used for attribution and debugging by the Segment team.
 */
function withTypewriterContext() {
  var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return _objectSpread(_objectSpread({}, message), {}, {
    context: _objectSpread(_objectSpread({}, message.context || {}), {}, {
      typewriter: {
        language: 'typescript',
        version: '7.4.1'
      }
    })
  });
}
/**
 * User viewed their shopping cart
 *
 * @param {CartViewed} props - The analytics properties that will be sent to Chord.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function cartViewed(props, options, callback) {
  var a = analytics();
  if (a) {
    a.track('Cart Viewed', props || {}, withTypewriterContext(options), callback);
  }
}
/**
 *
Fired when a customer visits the checkout#success and is mostly used for conversion campaigns
 *
 * @param {CheckoutCompleted} props - The analytics properties that will be sent to Chord.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function checkoutCompleted(props, options, callback) {
  var a = analytics();
  if (a) {
    a.track('Checkout Completed', props || {}, withTypewriterContext(options), callback);
  }
}
/**
 * User initiated the order process (a transaction is created)
 *
 * @param {CheckoutStarted} props - The analytics properties that will be sent to Chord.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function checkoutStarted(props, options, callback) {
  var a = analytics();
  if (a) {
    a.track('Checkout Started', props || {}, withTypewriterContext(options), callback);
  }
}
/**
 * User clicked on a Collection
 *
 * @param {CollectionClicked} props - The analytics properties that will be sent to Chord.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function collectionClicked(props, options, callback) {
  var a = analytics();
  if (a) {
    a.track('Collection Clicked', props || {}, withTypewriterContext(options), callback);
  }
}
/**
 * Coupon was applied on a user’s shopping cart or order
 *
 * @param {CouponApplied} props - The analytics properties that will be sent to Chord.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function couponApplied(props, options, callback) {
  var a = analytics();
  if (a) {
    a.track('Coupon Applied', props || {}, withTypewriterContext(options), callback);
  }
}
/**
 * Coupon was denied from a user’s shopping cart or order
 *
 * @param {CouponDenied} props - The analytics properties that will be sent to Chord.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function couponDenied(props, options, callback) {
  var a = analytics();
  if (a) {
    a.track('Coupon Denied', props || {}, withTypewriterContext(options), callback);
  }
}
/**
 * User entered a coupon on a shopping cart or order
 *
 * @param {CouponEntered} props - The analytics properties that will be sent to Chord.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function couponEntered(props, options, callback) {
  var a = analytics();
  if (a) {
    a.track('Coupon Entered', props || {}, withTypewriterContext(options), callback);
  }
}
/**
 * User removed a coupon from a cart or order
 *
 * @param {CouponRemoved} props - The analytics properties that will be sent to Chord.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function couponRemoved(props, options, callback) {
  var a = analytics();
  if (a) {
    a.track('Coupon Removed', props || {}, withTypewriterContext(options), callback);
  }
}
/**
 * Email entered in a form on the website
 *
 * @param {EmailCaptured} [props] - The analytics properties that will be sent to Chord.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function emailCaptured(props, options, callback) {
  var a = analytics();
  if (a) {
    a.track('Email Captured', props || {}, withTypewriterContext(options), callback);
  }
}
/**
 * Registrant starts to sign in
 *
 * @param {LoginStarted} [props] - The analytics properties that will be sent to Chord.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function loginStarted(props, options, callback) {
  var a = analytics();
  if (a) {
    a.track('Login Started', props || {}, withTypewriterContext(options), callback);
  }
}
/**
 * User completed the order
 *
 * @param {OrderCompleted} props - The analytics properties that will be sent to Chord.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function orderCompleted(props, options, callback) {
  var a = analytics();
  if (a) {
    a.track('Order Completed', props || {}, withTypewriterContext(options), callback);
  }
}
/**
 * User added a product to their shopping cart
 *
 * @param {ProductAdded} props - The analytics properties that will be sent to Chord.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function productAdded(props, options, callback) {
  var a = analytics();
  if (a) {
    a.track('Product Added', props || {}, withTypewriterContext(options), callback);
  }
}
/**
 * User clicked on a product
 *
 * @param {ProductClicked} props - The analytics properties that will be sent to Chord.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function productClicked(props, options, callback) {
  var a = analytics();
  if (a) {
    a.track('Product Clicked', props || {}, withTypewriterContext(options), callback);
  }
}
/**
 * User removed a product from their shopping cart
 *
 * @param {ProductRemoved} props - The analytics properties that will be sent to Chord.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function productRemoved(props, options, callback) {
  var a = analytics();
  if (a) {
    a.track('Product Removed', props || {}, withTypewriterContext(options), callback);
  }
}
/**
 * User viewed a product details
 *
 * @param {ProductViewed} props - The analytics properties that will be sent to Chord.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function productViewed(props, options, callback) {
  var a = analytics();
  if (a) {
    a.track('Product Viewed', props || {}, withTypewriterContext(options), callback);
  }
}
/**
 * Registrant Signs In
 *
 * @param {SignedIn} [props] - The analytics properties that will be sent to Chord.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function signedIn(props, options, callback) {
  var a = analytics();
  if (a) {
    a.track('Signed In', props || {}, withTypewriterContext(options), callback);
  }
}
/**
 * Registrant Signs Out
 *
 * @param {SignedOut} [props] - The analytics properties that will be sent to Chord.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function signedOut(props, options, callback) {
  var a = analytics();
  if (a) {
    a.track('Signed Out', props || {}, withTypewriterContext(options), callback);
  }
}
/**
 * A new stock request has been created
 *
 * @param {StockRequestCreated} props - The analytics properties that will be sent to Chord.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function stockRequestCreated(props, options, callback) {
  var a = analytics();
  if (a) {
    a.track('Stock Request Created', props || {}, withTypewriterContext(options), callback);
  }
}
/**
 * Subscription cancelled by the user, or failure to auto-renew.
 *
 * @param {SubscriptionCancelled} props - The analytics properties that will be sent to Chord.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function subscriptionCancelled(props, options, callback) {
  var a = analytics();
  if (a) {
    a.track('Subscription Cancelled', props || {}, withTypewriterContext(options), callback);
  }
}
/**
 * The upcoming order in a subscription is skipped, making the next order.
 *
 * @param {SubscriptionOrderSkipped} props - The analytics properties that will be sent to Chord.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function subscriptionOrderSkipped(props, options, callback) {
  var a = analytics();
  if (a) {
    a.track('Subscription Order Skipped', props || {}, withTypewriterContext(options), callback);
  }
}
/**
 * The subscription is paused and the date of processing is indicated on the `actionable_date` property. A `null` date indicates that the subscription is paused indefinitely.
 *
 * @param {SubscriptionPaused} props - The analytics properties that will be sent to Chord.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function subscriptionPaused(props, options, callback) {
  var a = analytics();
  if (a) {
    a.track('Subscription Paused', props || {}, withTypewriterContext(options), callback);
  }
}
/**
 * The paused subscription is resumed and the date of processing is indicated on the `actioanable_date` property.
 *
 * @param {SubscriptionResumed} props - The analytics properties that will be sent to Chord.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function subscriptionResumed(props, options, callback) {
  var a = analytics();
  if (a) {
    a.track('Subscription Resumed', props || {}, withTypewriterContext(options), callback);
  }
}
/**
 * User clicked on a product variation
 *
 * @param {VariantClicked} props - The analytics properties that will be sent to Chord.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function variantClicked(props, options, callback) {
  var a = analytics();
  if (a) {
    a.track('Variant Clicked', props || {}, withTypewriterContext(options), callback);
  }
}